const messages = require('./en-US/messages.json');

const extraMsg = {
  'Address Line 1 (Unit, Street)': 'Address Line 1 (Unit, Street)',
  'Address Line 2 (Province)': 'Address Line 2 (Province)',
  'Address Line 3 (City)': 'Address Line 3 (City)',
  'Postal Code': 'Postal Code',
  'Vehicle Brand': 'Vehicle Brand',
  'Vehicle Model': 'Vehicle Model',
  'Vehicle Identification Type': 'Vehicle Identification Type',
  'Vehicle Plate Number': 'Vehicle Plate Number',
  'Full Name': 'Full Name',
  'Vehicle Chassis Number': 'Vehicle Chassis Number',
  'Vehicle Engine Number': 'Vehicle Engine Number',
  'Vehicle Chassis & Engine Number': 'Vehicle Chassis & Engine Number',
  'Personal Identification Type': 'Personal Identification Type',
  female: 'female',
  male: 'male',
  Applicant: 'Applicant',
  'Address Line 1 (City/Province)': 'Address Line 1 (City/Province)',
  'Address Line 2 (District)': 'Address Line 2 (District)',
  'Address Line 3 (Ward)': 'Address Line 3 (Ward)',
  'Date of birth': 'Date of birth',
  'ID / Passport Number': 'ID / Passport Number',
  'Additional Insured': 'Additional Insured',
  'Insured People': 'Insured People',
  RelationShip: 'RelationShip',
  Policy: 'Policy',
  Self: 'Self',
  'Wife/ Husband': 'Wife/ Husband',
  'Child/ Adopted child': 'Child/ Adopted child',
  'Father/ Mother of your wife/ husband':
    'Father/ Mother of your wife/ husband',
  'Brother/ Sister': 'Brother/ Sister',
  'Father/ Mather': 'Father/ Mather',
  'Registration Date': 'Registration Date',
  'Seats Number': 'Seats Number',
  'Manufacture Date': 'Manufacture Date',
  'Policy Owner Name': 'Policy Owner Name',
  'Policy Owner Phone Number': 'Policy Owner Phone Number',
  'Vehicle Owner’s Name': 'Vehicle Owner’s Name',
  Model: 'Model',
  'Vehicle Front': 'Vehicle Front',
  'Vehicle Rear': 'Vehicle Rear',
  'Vehicle Left': 'Vehicle Left',
  'Vehicle Right': 'Vehicle Right',
  'Vehicle Identification Image': 'Vehicle Identification Image',
  'Vehicle Registration Stamp + Car VIN Number':
    'Vehicle Registration Stamp + Car VIN Number',
  'Chassis Number/Engine Series Number': 'Chassis Number/Engine Series Number',
  Family: 'Family',
};

const finalMsg = {
  ...messages,
  ...extraMsg,
};

export default finalMsg;
